module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-10.be23eac6.jpg";